export const tr = {
    isNotSet: 'belirtilmedi',
    perDay: 'günde'
};
